

/// <reference path="StockNote.ts" />

// Generated class WarehouseDeliveryNote_ManagedObject

class WarehouseDeliveryNote_ManagedObject extends StockNote
{
}
